function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { FormContainer } from '../form-container';
import { FormGroup } from './FormGroup';
export function FormItem(props) {
  var children = props.children,
      hasLabel = props.hasLabel,
      label = props.label,
      labelWidth = props.labelWidth,
      size = props.size,
      align = props.align,
      tooltip = props.tooltip,
      colon = props.colon,
      hint = props.hint,
      required = props.required,
      field = props.field,
      _props$captureChildEr = props.captureChildError,
      captureChildError = _props$captureChildEr === void 0 ? true : _props$captureChildEr,
      defaultValue = props.defaultValue,
      errorProcessor = props.errorProcessor,
      renderHelp = props.renderHelp,
      extra = _objectWithoutProperties(props, ["children", "hasLabel", "label", "labelWidth", "size", "align", "tooltip", "colon", "hint", "required", "field", "captureChildError", "defaultValue", "errorProcessor", "renderHelp"]);

  return React.createElement(FormGroup, {
    field: field,
    captureChildError: captureChildError,
    errorProcessor: errorProcessor,
    defaultValue: defaultValue
  }, function (_ref) {
    var valid = _ref.valid,
        msg = _ref.msg;

    var help = function help(msg) {
      return renderHelp ? renderHelp(msg) : msg;
    };

    return React.createElement(FormContainer, Object.assign({}, extra, {
      hasLabel: hasLabel,
      label: label,
      labelWidth: labelWidth,
      size: size,
      align: align,
      tooltip: tooltip,
      colon: colon,
      hint: hint,
      required: required,
      status: valid ? 'success' : 'error',
      help: !valid ? help(msg) : null
    }), children);
  });
}